import { UPDATE, UPDATEWALLET } from "./types";

export const updateTable = (data = []) => {
	return { tables: [...data], type: UPDATE };
};

